import React from 'react';
import { ArrowDropdown, ArrowDropUp, Box, makeStyles } from 'housecall-ui';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import ShoppingCartIcon from 'housecall-ui/dist/IconsAndImages/Icons/ShoppingCart';

import { useOnlineBookingReducer } from '../../state/useOnlineBookingReducer';
import { getItemFromCart, getQuantityFromItem } from '../../state/utils';
import { calculateSubTotalPrice } from '../../utils/calculatePrice';

import { CartItemDisplay } from './CartItemDisplay';

const useStyles = makeStyles(() => ({
  button: {
    flex: '0 1 auto',
    padding: 0,
    minHeight: 0,
    textTransform: 'none',
    width: '100%',
    justifyContent: 'stretch',
    alignItems: 'center',
  },
  buttonLabel: {
    justifyContent: 'space-between',
  },
  icon: {
    flex: '0 0 auto',
    minWidth: 0,
    verticalAlign: 'middle',
  },
}));

type Props = {
  onClick: () => void;
  open: boolean;
};

export const CartHeaderButton = ({ onClick, open }: Props) => {
  const { button, buttonLabel, icon } = useStyles();
  const { state } = useOnlineBookingReducer();

  const { cart } = state;
  const title = cart
    .map(
      (item) => `${getQuantityFromItem(item) > 1 ? `${getQuantityFromItem(item)}*` : ''}${getItemFromCart(item).name}`
    )
    .join(', ');

  const subTotal = calculateSubTotalPrice(cart);
  const showSubTotal = subTotal > 0;

  return (
    <Button classes={{ root: button, label: buttonLabel }} onClick={onClick}>
      <Box mr={1} className={icon}>
        <ShoppingCartIcon width="18px" height="18px" />
      </Box>
      <CartItemDisplay bold title={title} price={showSubTotal ? subTotal : undefined} />
      {open ? <ArrowDropUp className={icon} /> : <ArrowDropdown className={icon} />}
    </Button>
  );
};
